import { en } from './en'
import { fr } from './fr'

export const nav = {
  en,
  fr
}